import React, { useEffect, useState } from 'react';
import PoweredByJasper from '../../src/assets/images/PowerdByJasperIcon.svg';
import PowerdByJasperBuildrIcon from '../../src/assets/images/PowerdByJasperBuildrIcon.svg';
import SearchIcon from '../../src/assets/images/JasperSearchIcon.svg';
import JasperHeaderBackgroundImage from '../../src/assets/images/JasperHeadBackGroundImage.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setJasperHeaderSearch } from '../features/jasperHeaderSearch/jasperHeaderSearchSlice';
import { AnimatePresence, motion } from 'framer-motion';
import { RootState } from '../store';
import { PlatformType } from '../types/platforms';

const rotatingWords = ['Book', 'Class'];

const JasperHeader: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [wordIndex, setWordIndex] = useState(0);
    const [searchFocused, setSearchFocused] = useState(false);
    const dispatch = useDispatch();
    const product = useSelector(
        (state: RootState) => state.product
    ) as PlatformType;
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setSearchQuery(query);
        dispatch(setJasperHeaderSearch(query));
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setWordIndex((prev) => (prev + 1) % rotatingWords.length);
        }, 1500);
        return () => clearInterval(interval);
    }, []);

    return (
        <header
            className={`relative overflow-hidden w-full h-full`}
            style={{
                backgroundImage: `url(${JasperHeaderBackgroundImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
            }}
        >
            <div className="relative z-10 px-6 py-2 flex items-center justify-between">
                <div className="flex items-center space-x-3 ml-6">
                    {product !== 'Buildr' ? (
                        <img src={PoweredByJasper} alt="PoweredByJasper" />
                    ) : (
                        <img
                            src={PowerdByJasperBuildrIcon}
                            alt="PoweredByJasper"
                        />
                    )}
                </div>

                {/* SearchBar */}
                {product != 'Buildr' && (
                    <div className="flex-1 max-w-sm ml-8">
                        <form
                            onSubmit={(e) => e.preventDefault()}
                            className="relative"
                        >
                            <div className="relative flex justify-end mr-4">
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    onFocus={() => setSearchFocused(true)}
                                    onBlur={() => setSearchFocused(false)}
                                    placeholder=""
                                    className="max-w-[20rem] max-h-[4rem] px-4 py-2.5 pr-12 text-gray-700 bg-white bg-opacity-90 backdrop-blur-sm rounded-lg border-0 shadow-sm placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-300 focus:bg-white transition-all duration-200"
                                />

                                {/* Fake animated placeholder */}
                                {searchQuery === '' && !searchFocused && (
                                    <div className="absolute right-20 top-1/2 transform -translate-y-1/2 pointer-events-none text-[#666666] text-lg opacity-[60%] flex items-center h-full">
                                        <span className="mr-2">Search</span>

                                        <div className="w-[4.5rem] relative flex h-full items-center">
                                            <AnimatePresence mode="wait">
                                                <motion.span
                                                    key={wordIndex}
                                                    initial={{
                                                        y: 20,
                                                        opacity: 0,
                                                    }}
                                                    animate={{
                                                        y: 0,
                                                        opacity: 1,
                                                    }}
                                                    exit={{
                                                        y: -20,
                                                        opacity: 0,
                                                    }}
                                                    transition={{
                                                        duration: 0.6,
                                                        ease: 'anticipate',
                                                    }}
                                                    className="absolute left-0"
                                                >
                                                    {rotatingWords[wordIndex]}
                                                </motion.span>
                                            </AnimatePresence>
                                        </div>
                                    </div>
                                )}

                                <img
                                    src={SearchIcon}
                                    alt="Search Icon"
                                    className="absolute top-2 right-5 h-6 w-6"
                                />
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </header>
    );
};

export default React.memo(JasperHeader);
